import { adminRoot } from './defaultValues'

export default {
  app: `${adminRoot}`,
  unauthorized: '/unauthorized',
  login: '/user/login',
  dashboard: `${adminRoot}/dashboard`,
  pers: `${adminRoot}/pers`,
  modelPers: `${adminRoot}/model-pers`,
  riders: `${adminRoot}/rider`,
  globalUsers: `${adminRoot}/global-users`,
  companies: `${adminRoot}/company`,
  subscriptions: `${adminRoot}/subscription`,
  vehicles: `${adminRoot}/vehicle`,
  electronicKeys: `${adminRoot}/electronic-key`,
  electronicKeyModels: `${adminRoot}/electronic-key-model`,
  vehicleModels: `${adminRoot}/vehicle-model`,
  vehicleBrands: `${adminRoot}/vehicle-brand`,
  vehicleTypes: `${adminRoot}/vehicle-type`,
  sharings: `${adminRoot}/sharing`,
  visitorContacts: `${adminRoot}/visitor-contact`,
  archivedVisitorContacts: `${adminRoot}/archived-visitor-contact`,
  sections: `${adminRoot}/section`,
  stories: `${adminRoot}/story`,
  cardMarketplace: `${adminRoot}/card-marketplace`,
  privacyPolicy: `${adminRoot}/privacy-policy`,
  faq: `${adminRoot}/faq`,
  mostFrequentQuestion: `${adminRoot}/most-frequent-question`,
  scwPatent: `${adminRoot}/scw-patent`,
  languages: `${adminRoot}/language`,
  countries: `${adminRoot}/country`,
  timezones: `${adminRoot}/timezone`,
  currencies: `${adminRoot}/currency`,
  tagContactTypes: `${adminRoot}/tag-contact-type`,
  pilotTypes: `${adminRoot}/pilot-type`,
  cixiReferents: `${adminRoot}/cixi-referent`,
  platformPageTech: `${adminRoot}/platform-page-tech`,
  notificationTemplates: `${adminRoot}/notification-template`,
  notificationSimulator: `${adminRoot}/notification-simulator`,
  notificationRequests: `${adminRoot}/notification-request`,
  configNotificationSystem: `${adminRoot}/config-notification-system`,
  boUsers: `${adminRoot}/bo-user`,
  roles: `${adminRoot}/role`,
  rolesConfiguration: `${adminRoot}/role-configuration`,
  platformTech: `${adminRoot}/platform-tech`,
  businessSettings: `${adminRoot}/business-setting`,
  excludedDomains: `${adminRoot}/excluded-domain`,
  generalSettings: `${adminRoot}/general-setting`,
  regionalSettings: `${adminRoot}/regional-setting`,
  datetimeFormats: `${adminRoot}/datetime-format`,
  conditionalFeatures: `${adminRoot}/conditional-feature`,
  mailTemplates: `${adminRoot}/mail-template`,
  helpDeskButtons: `${adminRoot}/help-desk-button`,
  keysSettings: `${adminRoot}/key-setting`,
  interfaceLabels: `${adminRoot}/interface-label`,
  messages: `${adminRoot}/message`,
  connectivity: `${adminRoot}/connectivity`,
  documentation: `${adminRoot}/documentation`,
  partnerAPIKey: `${adminRoot}/partner-api-key`,
  simulatorVehicleAPIs: `${adminRoot}/simulator-pers-api`,
  topics: `${adminRoot}/topic`,
  logMails: `${adminRoot}/log-mail`,
  logRoutines: `${adminRoot}/log-routine`,
  logSwitchTo: `${adminRoot}/log-switch-to`,
  logAPIKey: `${adminRoot}/log-api-key`,
  persPackage: `${adminRoot}/pers-package`,
  persIOTMessages: `${adminRoot}/pers-iot-message`,
  configurationPersComn: `${adminRoot}/configuration-pers-comn`,
  odooSynchronization: `${adminRoot}/odoo-synchronization`,
  appVersioning: `${adminRoot}/app-versioning`,
  messageAfterConnection: `${adminRoot}/message-after-connection`,
  keyUsageSystemLogs: `${adminRoot}/key-usage-system-log`,
  companyCategories: `${adminRoot}/company-category`,
  serviceCenterAdmins: `${adminRoot}/service-center-admin`,
  alerts: `${adminRoot}/alert`,
  alertGroups: `${adminRoot}/alert-group`,
  alertTopics: `${adminRoot}/alert-topic`,
  alertLevels: `${adminRoot}/alert-level`,
  alertConfigurations: `${adminRoot}/alert-configuration`,
  odooSettings: `${adminRoot}/odoo-setting`,
  dataMapping: `${adminRoot}/data-mapping`,
  groupAlertFields: `${adminRoot}/group-alert-field`,
  firmwareVersionPERS: `${adminRoot}/firmware-pers`,
  kitConfigurationVersionPERS: `${adminRoot}/kit-configuration-pers`,
  kitUpdatePERS: `${adminRoot}/kit-update-pers`,
  configPERSTemplates: `${adminRoot}/config-pers-templates`,
  myProfile: `${adminRoot}/my-profile`,
  explanations: `${adminRoot}/explanations`,
  versions: `${adminRoot}/versions`
}
